"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerEncoderV = _interopRequireDefault(require("./SeoManagerEncoderV1"));

var _SeoManagerEncoderV2 = _interopRequireDefault(require("./SeoManagerEncoderV2"));

var _converterHelper = require("./converterHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SEO_VERSIONS = {
  v1: 'seo_v1',
  v2: 'seo_v2'
};

var SeoManagerEncoder = /*#__PURE__*/function () {
  function SeoManagerEncoder(domain, lang, supported_lang_slug) {
    _classCallCheck(this, SeoManagerEncoder);

    this.domain = domain;
    this.lang = lang;
    this.supported_lang_slug = supported_lang_slug;
    this.data = {};
    this.num_levels = 0;
    this.immotype = undefined;
    this.encode_parts = {};
    this.encode_qs = [];
  }

  _createClass(SeoManagerEncoder, [{
    key: "encode",
    value: function encode(params) {
      var version = params.version;
      delete params.version;
      delete params.is301Torino;

      switch (version) {
        case SEO_VERSIONS.v1:
          var seov1 = new _SeoManagerEncoderV["default"](this);
          return seov1.encode(params);

        case SEO_VERSIONS.v2:
        default:
          var seov2 = new _SeoManagerEncoderV2["default"](this);
          var paramsV2 = params.seo_manager_type === 'old-seo-url' ? (0, _converterHelper.convertParamsForEncode)(this.lang, params) : params;
          return seov2.encode(paramsV2);
      }
    }
  }, {
    key: "encodeHrefLang",
    value: function encodeHrefLang(params) {
      var version = params.version;
      delete params.version;

      switch (version) {
        case SEO_VERSIONS.v1:
          var seov1 = new _SeoManagerEncoderV["default"](this);
          return seov1.encodeHrefLang(params);

        case SEO_VERSIONS.v2:
        default:
          var seov2 = new _SeoManagerEncoderV2["default"](this);
          var paramsV2 = params.seo_manager_type === 'old-seo-url' ? (0, _converterHelper.convertParamsForEncode)(this.lang, params) : params;
          return seov2.encodeHrefLang(paramsV2);
      }
    }
  }]);

  return SeoManagerEncoder;
}();

var _default = SeoManagerEncoder;
exports["default"] = _default;